// OCPI Token Types
export const OCPI_TOKEN_TYPES = {
  RFID: 'RFID',
  MOBILE: 'APP_USER',
  AD_HOC_USER: 'AD_HOC_USER',
  OTHER: 'OTHER'
};

// OCPI Token Types Array
export const OCPI_TOKEN_TYPES_ARRAY = [
  OCPI_TOKEN_TYPES.RFID,
  OCPI_TOKEN_TYPES.MOBILE,
  OCPI_TOKEN_TYPES.AD_HOC_USER,
  OCPI_TOKEN_TYPES.OTHER
];

// OCPI Tariff Types
export const OCPI_TARIFF_TYPES = {
  REGULAR: 'REGULAR',
  FAST: 'FAST',
  GREEN: 'GREEN',
  CHEAP: 'CHEAP',
  PREMIUM: 'PREMIUM',
  OFF_PEAK: 'OFF_PEAK',
  PEAK: 'PEAK'
};

// OCPI Tariff Types Array
export const OCPI_TARIFF_TYPES_ARRAY = [
  OCPI_TARIFF_TYPES.REGULAR,
  OCPI_TARIFF_TYPES.FAST,
  OCPI_TARIFF_TYPES.GREEN,
  OCPI_TARIFF_TYPES.CHEAP,
  OCPI_TARIFF_TYPES.PREMIUM,
  OCPI_TARIFF_TYPES.OFF_PEAK,
  OCPI_TARIFF_TYPES.PEAK
];

// OCPI Currencies
export const OCPI_CURRENCIES = [
  { code: 'INR', name: 'Indian Rupee', symbol: '₹' },
  { code: 'EUR', name: 'Euro', symbol: '€' },
  { code: 'USD', name: 'US Dollar', symbol: '$' },
  { code: 'GBP', name: 'British Pound', symbol: '£' },
  { code: 'CHF', name: 'Swiss Franc', symbol: 'CHF' },
  { code: 'NOK', name: 'Norwegian Krone', symbol: 'NOK' },
  { code: 'SEK', name: 'Swedish Krona', symbol: 'SEK' },
  { code: 'DKK', name: 'Danish Krone', symbol: 'DKK' }
];

// OCPI Energy Categories
export const OCPI_ENERGY_CATEGORIES = [
  { code: 'ELECTRICITY', name: 'Electricity' },
  { code: 'SOLAR', name: 'Solar Energy' },
  { code: 'WIND', name: 'Wind Energy' },
  { code: 'HYDRO', name: 'Hydroelectric' },
  { code: 'NUCLEAR', name: 'Nuclear Energy' },
  { code: 'GEOTHERMAL', name: 'Geothermal' }
];

// OCPI Tariff Elements
export const OCPI_TARIFF_ELEMENTS = [
  { code: 'ENERGY', name: 'Energy (per kWh)' },
  { code: 'TIME', name: 'Time (per hour)' },
  { code: 'FLAT', name: 'Flat Rate' },
  { code: 'PARKING_TIME', name: 'Parking Time' },
  { code: 'RESERVATION_TIME', name: 'Reservation Time' }
];

// OCPI Tariff Restrictions
export const OCPI_TARIFF_RESTRICTIONS = [
  { code: 'NONE', name: 'No Restrictions' },
  { code: 'RESIDENT', name: 'Residents Only' },
  { code: 'STAFF', name: 'Staff Only' },
  { code: 'CUSTOMER', name: 'Customers Only' },
  { code: 'MEMBER', name: 'Members Only' }
];

// OCPI Whitelist Types
export const OCPI_WHITELIST_TYPES = {
  ALLOWED: 'ALLOWED',
  ALWAYS: 'ALWAYS',
  ALLOWED_OFFLINE: 'ALLOWED_OFFLINE',
  NEVER: 'NEVER'
};

// OCPI Whitelist Types Array
export const OCPI_WHITELIST_TYPES_ARRAY = [
  OCPI_WHITELIST_TYPES.ALLOWED,
  OCPI_WHITELIST_TYPES.ALWAYS,
  OCPI_WHITELIST_TYPES.ALLOWED_OFFLINE,
  OCPI_WHITELIST_TYPES.NEVER
];

// OCPI Profile Types
export const OCPI_PROFILE_TYPES = {
  REGULAR: 'REGULAR',
  FAST: 'FAST',
  GREEN: 'GREEN',
  CHEAP: 'CHEAP'
};

// OCPI Profile Types Array
export const OCPI_PROFILE_TYPES_ARRAY = [
  OCPI_PROFILE_TYPES.REGULAR,
  OCPI_PROFILE_TYPES.FAST,
  OCPI_PROFILE_TYPES.GREEN,
  OCPI_PROFILE_TYPES.CHEAP
];

// OCPI Countries
export const OCPI_COUNTRIES = [
  { code: 'IN', name: 'India' },
  { code: 'NL', name: 'Netherlands' },
  { code: 'DE', name: 'Germany' },
  { code: 'FR', name: 'France' },
  { code: 'GB', name: 'United Kingdom' },
  { code: 'IT', name: 'Italy' },
  { code: 'ES', name: 'Spain' },
  { code: 'BE', name: 'Belgium' },
  { code: 'AT', name: 'Austria' },
  { code: 'CH', name: 'Switzerland' },
  { code: 'NO', name: 'Norway' },
  { code: 'SE', name: 'Sweden' },
  { code: 'DK', name: 'Denmark' },
  { code: 'FI', name: 'Finland' },
  { code: 'PL', name: 'Poland' },
  { code: 'CZ', name: 'Czech Republic' },
  { code: 'HU', name: 'Hungary' },
  { code: 'RO', name: 'Romania' },
  { code: 'BG', name: 'Bulgaria' },
  { code: 'HR', name: 'Croatia' },
  { code: 'SI', name: 'Slovenia' }
];

// OCPI Languages
export const OCPI_LANGUAGES = [
  { code: 'en', name: 'English' },
  { code: 'de', name: 'German' },
  { code: 'fr', name: 'French' },
  { code: 'nl', name: 'Dutch' },
  { code: 'it', name: 'Italian' },
  { code: 'es', name: 'Spanish' },
  { code: 'sv', name: 'Swedish' },
  { code: 'da', name: 'Danish' },
  { code: 'fi', name: 'Finnish' },
  { code: 'no', name: 'Norwegian' },
  { code: 'pl', name: 'Polish' },
  { code: 'cs', name: 'Czech' },
  { code: 'hu', name: 'Hungarian' },
  { code: 'ro', name: 'Romanian' },
  { code: 'bg', name: 'Bulgarian' },
  { code: 'hr', name: 'Croatian' },
  { code: 'sl', name: 'Slovenian' }
];

// OCPI Commands
export const OCPI_COMMANDS = {
  START_SESSION: 'START_SESSION',
  STOP_SESSION: 'STOP_SESSION',
  RESERVE_NOW: 'RESERVE_NOW',
  CANCEL_RESERVATION: 'CANCEL_RESERVATION',
  UNLOCK_CONNECTOR: 'UNLOCK_CONNECTOR'
};

// OCPI Commands Array
export const OCPI_COMMANDS_ARRAY = [
  OCPI_COMMANDS.START_SESSION,
  OCPI_COMMANDS.STOP_SESSION,
  OCPI_COMMANDS.RESERVE_NOW,
  OCPI_COMMANDS.CANCEL_RESERVATION,
  OCPI_COMMANDS.UNLOCK_CONNECTOR
];

// OCPI Command Types with labels and colors
export const OCPI_COMMAND_TYPES = [
  { value: OCPI_COMMANDS.START_SESSION, label: 'Start Session', color: '#4caf50' },
  { value: OCPI_COMMANDS.STOP_SESSION, label: 'Stop Session', color: '#f44336' },
  { value: OCPI_COMMANDS.UNLOCK_CONNECTOR, label: 'Unlock Connector', color: '#2196f3' },
  { value: OCPI_COMMANDS.RESERVE_NOW, label: 'Reserve Now', color: '#9c27b0' },
  { value: OCPI_COMMANDS.CANCEL_RESERVATION, label: 'Cancel Reservation', color: '#ff9800' }
];

// OCPI Command Status
export const OCPI_COMMAND_STATUS = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED'
};

// OCPI Command Status Array
export const OCPI_COMMAND_STATUS_ARRAY = [
  OCPI_COMMAND_STATUS.PENDING,
  OCPI_COMMAND_STATUS.PROCESSING,
  OCPI_COMMAND_STATUS.COMPLETED,
  OCPI_COMMAND_STATUS.FAILED,
  OCPI_COMMAND_STATUS.CANCELLED
];

// Mock Locations for development
export const MOCK_LOCATIONS = [
  { id: 'LOC_001', name: 'Downtown Station' },
  { id: 'LOC_002', name: 'Mall Parking' },
  { id: 'LOC_003', name: 'Highway Rest Stop' }
];

// Mock EVSEs for development
export const MOCK_TOKEN = [
  { id: 1, name: 'edd0c230ddaa' },
];

// OCPI Roles
export const OCPI_ROLES = {
  CPO: 'CPO',
  EMSP: 'EMSP',
  HUB: 'HUB',
  NAP: 'NAP'
};

// OCPI Roles Array
export const OCPI_ROLES_ARRAY = [
  OCPI_ROLES.CPO,
  OCPI_ROLES.EMSP,
  OCPI_ROLES.HUB,
  OCPI_ROLES.NAP
];

// OCPI Versions
export const OCPI_VERSIONS = {
  V2_1_1: '2.1.1',
  V2_2_1: '2.2.1'
};

// OCPI Versions Array
export const OCPI_VERSIONS_ARRAY = [
  OCPI_VERSIONS.V2_1_1,
  OCPI_VERSIONS.V2_2_1
];

// Initial Values for Forms

// Token Form Initial Values
export const TOKEN_FORM_INITIAL_VALUES = {
  countryCode: '',
  partyId: '',
  uid: '',
  type: OCPI_TOKEN_TYPES.RFID,
  whitelist: OCPI_WHITELIST_TYPES.ALLOWED,
  contractId: '',
  issuer: '',
  defaultProfileType: OCPI_PROFILE_TYPES.REGULAR,
  visualNumber: '',
  groupId: '',
  language: 'en',
  defaultProfileType: OCPI_PROFILE_TYPES.REGULAR,
  energyContract: {
    supplierName: '',
    contractId: ''
  },
  valid: true
};

// Tariff Form Initial Values
export const TARIFF_FORM_INITIAL_VALUES = {
  countryCode: '',
  partyId: '',
  id: '',
  currency: 'EUR',
  type: OCPI_TARIFF_TYPES.REGULAR,
  elements: [
    {
      price_components: [
        {
          type: 'ENERGY',
          price: 0.30,
          step_size: 1
        }
      ]
    }
  ],
  restrictions: OCPI_TARIFF_RESTRICTIONS[0].code,
  energy_category: OCPI_ENERGY_CATEGORIES[0].code,
  last_updated: new Date().toISOString(),
  valid: true,
  description: '',
  min_price: 0,
  max_price: null
};

// Command Form Initial Values
export const COMMAND_FORM_INITIAL_VALUES = {
  command: '',
  location_id: '',
  evse_uid: '',
  connector_id: '',
  authorization_reference: '',
  reservation_id: '',
  session_id: '',
  responseUrl: '',
  notes: ''
};

// Command Form Initial Values by Type
export const getCommandFormInitialValues = (commandType) => {
  const baseValues = {
    command_type: commandType,
    notes: ''
  };

  switch (commandType) {
    case OCPI_COMMANDS.START_SESSION:
      return {
        ...baseValues,
        command: OCPI_COMMANDS.START_SESSION,
        location_id: '',
        evse_uid: '',
        connector_id: '',
        authorization_reference: ''
      };
    
    case OCPI_COMMANDS.STOP_SESSION:
      return {
        ...baseValues,
        command: OCPI_COMMANDS.STOP_SESSION,
        session_id: ''
      };
    
    case OCPI_COMMANDS.UNLOCK_CONNECTOR:
      return {
        ...baseValues,
        command: OCPI_COMMANDS.UNLOCK_CONNECTOR,
        location_id: '',
        evse_uid: '',
        connector_id: ''
      };
    
    case OCPI_COMMANDS.RESERVE_NOW:
      return {
        ...baseValues,
        command: OCPI_COMMANDS.RESERVE_NOW,
        location_id: '',
        evs_uid: '',
        authorization_reference: '',
        reservation_id: ''
      };
    
    case OCPI_COMMANDS.CANCEL_RESERVATION:
      return {
        ...baseValues,
        command: OCPI_COMMANDS.CANCEL_RESERVATION,
        reservation_id: ''
      };
    
    default:
      return baseValues;
  }
};

// Partner Form Initial Values
export const PARTNER_FORM_INITIAL_VALUES = {
  partnerName: '',
  partyId: '',
  countryCode: '',
  baseUrl: '',
  roles: [],
  version: OCPI_VERSIONS.V2_2_1
};

// Search Form Initial Values
export const SEARCH_FORM_INITIAL_VALUES = {
  searchTerm: ''
};

// Pagination Initial Values
export const PAGINATION_INITIAL_VALUES = {
  offset: 0,
  limit: 50,
  total: 0
};

// Filter Initial Values
export const FILTER_INITIAL_VALUES = {
  typeFilter: 'All Types',
  statusFilter: 'All Status',
  searchTerm: ''
};

// Export all constants
export default {
  OCPI_TOKEN_TYPES,
  OCPI_TOKEN_TYPES_ARRAY,
  OCPI_TARIFF_TYPES,
  OCPI_TARIFF_TYPES_ARRAY,
  OCPI_CURRENCIES,
  OCPI_ENERGY_CATEGORIES,
  OCPI_TARIFF_ELEMENTS,
  OCPI_TARIFF_RESTRICTIONS,
  OCPI_WHITELIST_TYPES,
  OCPI_WHITELIST_TYPES_ARRAY,
  OCPI_PROFILE_TYPES,
  OCPI_PROFILE_TYPES_ARRAY,
  OCPI_COUNTRIES,
  OCPI_LANGUAGES,
  OCPI_COMMANDS,
  OCPI_COMMANDS_ARRAY,
  OCPI_COMMAND_TYPES,
  OCPI_COMMAND_STATUS,
  OCPI_COMMAND_STATUS_ARRAY,
  MOCK_LOCATIONS,
  MOCK_TOKEN,
  OCPI_ROLES,
  OCPI_ROLES_ARRAY,
  OCPI_VERSIONS,
  OCPI_VERSIONS_ARRAY,
  TOKEN_FORM_INITIAL_VALUES,
  TARIFF_FORM_INITIAL_VALUES,
  COMMAND_FORM_INITIAL_VALUES,
  PARTNER_FORM_INITIAL_VALUES,
  SEARCH_FORM_INITIAL_VALUES,
  PAGINATION_INITIAL_VALUES,
  FILTER_INITIAL_VALUES
}; 